export default __webpack_public_path__ + "static/media/accuracy-icon.5053a1d8.svg";